import type { TableCellTarget } from '@gitbook/api-client';
import type { Document } from '@gitbook/slate';

/**
 * Construct a plain-text summary for the given node.
 */
export function constructNodeSummary(
    pageDocument: Document,
    nodeKey: string,
    tableCell?: TableCellTarget
): string | undefined {
    let nodeSummary: string | undefined;

    const node = pageDocument.getDescendant(nodeKey);
    if (node?.text) {
        nodeSummary = node.text;
    } else if (tableCell) {
        nodeSummary = 'Comment on table cell';
    } else if (node?.isBlock()) {
        nodeSummary = `Comment on ${node.type}`;
    }

    return nodeSummary;
}
